import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';
import { getCurrentCompanyId } from '../lib/company';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Megaphone, Upload, Save } from 'lucide-react';

const imgUrl = (id) => `${process.env.REACT_APP_BACKEND_URL}/api/public/files/${id}`;

// Los encargados de cada tienda administran sus 3 banners promocionales de la vitrina
export default function Promotions() {
  const { user } = useAuth();
  const cid = user?.role_id === 'admin' ? user.company_id : getCurrentCompanyId();
  const [name, setName] = useState('');
  const [banners, setBanners] = useState([{}, {}, {}]);
  useEffect(() => {
    if (!cid) return;
    api.getBanners(cid).then((r) => { setName(r.data.name); const b = r.data.banners || []; setBanners([0, 1, 2].map((i) => b[i] || {})); }).catch(() => {});
  }, [cid]);
  if (!cid) return <p className="p-6 text-[#64748B]">Selecciona una tienda arriba en el panel.</p>;
  const upload = async (i, file) => {
    const fd = new FormData(); fd.append('file', file);
    try { const r = await api.uploadFile(fd, 'banner'); setBanners(banners.map((b, j) => (j === i ? { ...b, file_id: r.data.file_id } : b))); }
    catch (e) { toast.error(e.response?.data?.detail || 'SalesPRO: Error al subir'); }
  };
  const set = (i, k, v) => setBanners(banners.map((b, j) => (j === i ? { ...b, [k]: v } : b)));
  const save = async () => { try { await api.setBanners(cid, banners.filter((b) => b.file_id)); toast.success('SalesPRO: Promociones publicadas en la vitrina'); } catch (e) { toast.error(e.response?.data?.detail || 'SalesPRO: Error'); } };
  return (
    <div className="space-y-4" data-testid="promotions-page">
      <div className="flex flex-wrap justify-between items-end gap-2">
        <h1 className="font-heading text-3xl font-black text-[#022C22] flex items-center gap-2"><Megaphone /> Promociones · {name}</h1>
        <Button onClick={save} data-testid="banners-save"><Save size={14} className="mr-1" /> Publicar</Button>
      </div>
      <p className="text-sm text-[#64748B]">Hasta 3 flyers. Se muestran justo después del banner principal en la página de tu tienda y en la vitrina global. Tamaño recomendado: 1080×1350 px (vertical) o 1200×628 px.</p>
      <div className="grid md:grid-cols-3 gap-4">
        {banners.map((b, i) => (
          <Card key={i} data-testid={`banner-slot-${i}`}><CardContent className="p-3 space-y-2">
            <label className="block aspect-[4/5] rounded-lg border-2 border-dashed border-[#CBD5E1] overflow-hidden cursor-pointer bg-[#F8FAFC] grid place-items-center">
              {b.file_id ? <img src={imgUrl(b.file_id)} alt="" className="w-full h-full object-cover" /> : <span className="text-sm text-[#64748B] flex items-center gap-1"><Upload size={14} /> Subir flyer {i + 1}</span>}
              <input type="file" accept="image/*" className="hidden" onChange={(e) => e.target.files[0] && upload(i, e.target.files[0])} data-testid={`banner-file-${i}`} />
            </label>
            <Input placeholder="Título (opcional)" value={b.title || ''} onChange={(e) => set(i, 'title', e.target.value)} />
            <Input placeholder="Válido hasta (ej. 31/10)" value={b.valid_until || ''} onChange={(e) => set(i, 'valid_until', e.target.value)} />
            {b.file_id && <Button variant="outline" size="sm" onClick={() => set(i, 'file_id', null)}>Quitar</Button>}
          </CardContent></Card>))}
      </div>
    </div>
  );
}
